export default __webpack_public_path__ + "static/media/two.59358974.svg";